import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import {
    NEWS_DETAIL
} from '../actions';

import {
    NewsDetailSuccess,
    NewsDetailError
} from '../actions';

export function* watchNewsDetail() {
    yield takeEvery(NEWS_DETAIL, onNewsDetail);
}

function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

const onNewsDetailAsync = async (payload) => {
   // let token = await getToken(authFB);
    const response = await fetch(servicePath + 'news/detail', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return response;
};

function* onNewsDetail(data) {
    try {
        const response = yield call(onNewsDetailAsync, data.payload);
        const articles = JSON.parse(response.data);
        yield put(NewsDetailSuccess(articles.articles));
    } catch (error) {
        yield put(NewsDetailError(error));
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchNewsDetail)
    ]);
}
